"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Alert = function Alert(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M12.007 18.881a7.989 7.989 0 01-1.466-.155.808.808 0 00-.642.166 6.59 6.59 0 01-3.143 1.235.34.34 0 01-.318-.53c.44-.547.755-1.184.925-1.865a.504.504 0 00-.188-.49 6.612 6.612 0 01-2.668-5.236c0-3.792 3.357-6.875 7.5-6.875 4.142 0 7.5 3.083 7.5 6.876 0 3.792-3.358 6.874-7.5 6.874zm-.002-2.5a.937.937 0 100-1.874.937.937 0 000 1.874zm.624-8.75h-1.243a.316.316 0 00-.32.33l.287 5.312c.01.168.15.298.319.296h.671a.317.317 0 00.32-.296l.285-5.313a.316.316 0 00-.319-.329z"
  }));
};

var _default = (0, _react.forwardRef)(Alert);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Alert, "Alert", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Alert.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Alert.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9BbGVydC50c3giXSwibmFtZXMiOlsiQWxlcnQiLCJwcm9wcyIsInJlZiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztBQUFBOzs7Ozs7Ozs7Ozs7O0FBRUEsSUFBTUEsS0FBcUUsR0FBRyxTQUF4RUEsS0FBd0UsQ0FBQ0MsS0FBRCxFQUFRQyxHQUFSO0FBQUEsU0FDNUU7QUFBSyxJQUFBLEtBQUssRUFBRSxFQUFaO0FBQWdCLElBQUEsTUFBTSxFQUFFLEVBQXhCO0FBQTRCLElBQUEsT0FBTyxFQUFDO0FBQXBDLEtBQW9ERCxLQUFwRDtBQUEyRCxJQUFBLEdBQUcsRUFBRUM7QUFBaEUsTUFDRTtBQUNFLElBQUEsSUFBSSxFQUFDLGNBRFA7QUFFRSxJQUFBLENBQUMsRUFBQztBQUZKLElBREYsQ0FENEU7QUFBQSxDQUE5RTs7ZUFTZSx1QkFBV0YsS0FBWCxDOzs7Ozs7Ozs7Ozs7OzBCQVRUQSxLIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IGZvcndhcmRSZWYsIFJlZkZvcndhcmRpbmdDb21wb25lbnQsIFNWR1Byb3BzIH0gZnJvbSAncmVhY3QnO1xuXG5jb25zdCBBbGVydDogUmVmRm9yd2FyZGluZ0NvbXBvbmVudDxTVkdTVkdFbGVtZW50LCBTVkdQcm9wczxTVkdTVkdFbGVtZW50Pj4gPSAocHJvcHMsIHJlZikgPT4gKFxuICA8c3ZnIHdpZHRoPXsyNH0gaGVpZ2h0PXsyNH0gdmlld0JveD1cIjAgMCAyNCAyNFwiIHsuLi5wcm9wc30gcmVmPXtyZWZ9PlxuICAgIDxwYXRoXG4gICAgICBmaWxsPVwiY3VycmVudENvbG9yXCJcbiAgICAgIGQ9XCJNMTIuMDA3IDE4Ljg4MWE3Ljk4OSA3Ljk4OSAwIDAxLTEuNDY2LS4xNTUuODA4LjgwOCAwIDAwLS42NDIuMTY2IDYuNTkgNi41OSAwIDAxLTMuMTQzIDEuMjM1LjM0LjM0IDAgMDEtLjMxOC0uNTNjLjQ0LS41NDcuNzU1LTEuMTg0LjkyNS0xLjg2NWEuNTA0LjUwNCAwIDAwLS4xODgtLjQ5IDYuNjEyIDYuNjEyIDAgMDEtMi42NjgtNS4yMzZjMC0zLjc5MiAzLjM1Ny02Ljg3NSA3LjUtNi44NzUgNC4xNDIgMCA3LjUgMy4wODMgNy41IDYuODc2IDAgMy43OTItMy4zNTggNi44NzQtNy41IDYuODc0em0tLjAwMi0yLjVhLjkzNy45MzcgMCAxMDAtMS44NzQuOTM3LjkzNyAwIDAwMCAxLjg3NHptLjYyNC04Ljc1aC0xLjI0M2EuMzE2LjMxNiAwIDAwLS4zMi4zM2wuMjg3IDUuMzEyYy4wMS4xNjguMTUuMjk4LjMxOS4yOTZoLjY3MWEuMzE3LjMxNyAwIDAwLjMyLS4yOTZsLjI4NS01LjMxM2EuMzE2LjMxNiAwIDAwLS4zMTktLjMyOXpcIlxuICAgIC8+XG4gIDwvc3ZnPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgZm9yd2FyZFJlZihBbGVydCk7XG4iXX0=